import { createSlice } from "@reduxjs/toolkit";

export const shopSlice = createSlice({
    name: "shop",
    initialState: {
        products: [],
        cart: {},
        orders: {},
    },
    reducers: {
        updateShop: (state, action) => {
            state.products = action.payload.products ?? state.products;
            state.cart = action.payload.cart ?? state.cart;
            state.orders = action.payload.orders ?? state.orders;
        },
        addToCart: (state, action) => {
            state.cart[action.payload.personId].push(action.payload);
        },
        deleteFromCart: (state, action) => {
            state.cart[action.payload.personId] = state.cart[action.payload.personId].filter(item => item.id !== action.payload.id);
        },
        clearCart: (state, action) => {
            state.cart[action.payload.personId] = [];
            state.orders[action.payload.personId] = action.payload.orders;
        },
        clearShop: state => {
            state.products = [];
            state.cart = {};
            state.orders = {};
        },
    }
});

// Action creators are generated for each case reducer function
export const { updateShop, addToCart, deleteFromCart, clearShop, clearCart } = shopSlice.actions
export default shopSlice.reducer;
